@Component({
  selector: 'app-dialog-new-version',
  templateUrl: './dialog-new-version.component.html'
})
export class DialogNewVersionComponent {
  constructor(private dialogRef: MatDialogRef<DialogNewVersionComponent>) {
  }

  onContinue() {
    this.dialogRef.close('continue');
  }

  onOpenNewVersion() {
    // Substitua pela URL da nova versão
    window.open('https://app.apureh.com', '_self');
    this.dialogRef.close('new-version');
  }
}

import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
